import { SingletonRedirect } from "@/components/SingletonRedirect";

export function AttackProtectionList() {
  return <SingletonRedirect resource="attack-protection" />;
}
